<script lang="ts">
  import { loginUser } from '../components/auth/LoginUser';

  const pdfs = [
      {
        serviceCode: 'HIKARI_COLLABO',
        pdf: 'U-NEXT光コラボレーション_譲渡・承継・改称・住所変更手続き申請書'
      },
      {
        serviceCode: 'HIKARI_01',
        pdf: 'U-NEXT光01 譲渡・承継・改称・住所変更手続き申請書'
      },
      {
        serviceCode: 'UMOBILE_D',
        pdf: 'U-mobile 承継・改称・住所変更手続き申請書'
      },
      {
        serviceCode: 'UMOBILE_D_ENECOM',
        pdf: 'U-mobile 承継・改称・住所変更手続き申請書'
      },
      {
        serviceCode: 'WITHUNET',
        pdf: 'withU net 承継・改称・住所変更手続き申請書'
      },
      {
        serviceCode: 'UMOBILE_EA',
        pdf: 'U-mobileE 承継・改称・住所変更手続き申請書'
      },
      {
        serviceCode: 'UMOBILE_SONET',
        pdf: 'U-mobileLTE 承継・改称・住所変更手続き申請書'
      },
      {
        serviceCode: 'UMOBILE_PREMIUM',
        pdf: 'U-mobilePremium 承継・改称・住所変更手続き申請書'
      }
    ],
    pdf = pdfs.find((v) => v.serviceCode === $loginUser.businessCode).pdf;
</script>

<div class="mb-5 screen-title">
  <span class="text-gray-700 text-2xl font-bold">契約者情報</span>
</div>

<div class="mb-4">
  <div class="rounded bg-white border-t-4 border-green-400">
    <div class="shadow rounded-lg bg-gray-50 border-1 p-4 mb-10">
      <div class="flex flex-col">
        <div class="mt-2 mb-5">
          <div class="min-w-full">
            <div class="mb-5">■お手続き方法</div>
            <li>1：下記の手続きに関する書類を選択します。</li>
            <li>2：表示されたPDFを印刷します。</li>
            <li>3：印刷した書類の中から、目的の手続きに関する書類へ必要情報を記入します。</li>
            <li>4：同封が必要な書類をご確認のうえ、書類一式をご郵送ください。</li>
            {#if pdf}
              <div class="ml-5 mt-5">
                <a href="pdf/{pdf}.pdf" rel="noopener noreferrer" target="_blank">
                  ・{pdf}
                </a>
              </div>
            {/if}
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<style lang="postcss">
  li {
    list-style: none;
  }
  .screen-title {
    text-align: left;
  }
  @media screen and (max-width: 640px) {
    .screen-title {
      text-align: center;
    }
  }
</style>
